(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["no-restock"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mooiys-outlet')) {
  customElements.define('mooiys-outlet', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      const start = () => {
        if (this.initialized || !this.querySelector('[data-labels]')) return;
        this.initialized = true;
        this.initialize();
      };
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', start, { once: true });
      } else {
        start();
      }
    }

    initialize() {
      let map, labels;
      try {
        map = JSON.parse(this.querySelector('[data-map]').textContent);
        labels = JSON.parse(this.querySelector('[data-labels]').textContent);
      } catch {
        return;
      }
      const grid = this.querySelector('[data-grid]');
      const nodes = Array.from(grid.querySelectorAll('[data-product]'));
      if (!nodes.length) return;
      const initial = Number(this.dataset.initial) || 8;
      const step = Number(this.dataset.step) || 12;
      const state = { category: 'all', query: '', price: 'all', sort: 'featured', limit: initial };
      const groups = new Map();
      const selection = new Map();
      const normalize = (value) => String(value).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().trim();
      const products = nodes.map((node, index) => {
        const meta = map[node.dataset.handle] || {};
        const item = {
          node, handle: node.dataset.handle,
          title: meta.name || node.dataset.title,
          fullTitle: node.dataset.title,
          category: meta.category || 'other',
          group: meta.group || node.dataset.handle,
          color: meta.color || [],
          price: Number(node.dataset.price),
          saving: Number(node.dataset.saving),
          available: node.dataset.available === 'true',
          rank: Number.isFinite(meta.rank) ? meta.rank : 1000 + index,
          index
        };
        node.querySelector('[data-title-link]').textContent = item.title;
        node.querySelector('[data-color-label]').textContent = item.color[0] || labels.categories[item.category];
        item.searchText = normalize([item.title, item.fullTitle, item.color[0], labels.categories[item.category]].join(' '));
        if (!groups.has(item.group)) groups.set(item.group, []);
        groups.get(item.group).push(item);
        return item;
      });
      const grouped = Array.from(groups.entries()).map(([id, members]) => ({
        id, members, rank: Math.min(...members.map((item) => item.rank))
      })).sort((a, b) => a.rank - b.rank);
      const categoryBox = this.querySelector('[data-categories]');
      const categoryButtons = new Map();
      const makeCategory = (key, text, count) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'mno-category';
        button.dataset.category = key;
        button.append(document.createTextNode(text));
        const badge = document.createElement('span');
        badge.textContent = count;
        button.append(badge);
        categoryBox.append(button);
        categoryButtons.set(key, button);
      };
      makeCategory('all', labels.all, products.length);
      Object.entries(labels.categories).forEach(([key, label]) => {
        const count = products.filter((item) => item.category === key).length;
        if (count) makeCategory(key, label, count);
      });
      const hex = (color) => /^#[0-9a-f]{6}$/i.test(color || '') ? color : '#808080';
      products.forEach((item) => {
        const siblings = groups.get(item.group);
        if (siblings.length < 2 || !item.color.length) return;
        const wrap = item.node.querySelector('[data-swatches]');
        wrap.replaceChildren();
        siblings.forEach((sibling) => {
          const button = document.createElement('button');
          button.className = 'mno-swatch';
          button.type = 'button';
          button.dataset.choose = sibling.handle;
          button.dataset.group = item.group;
          button.dataset.soldOut = String(!sibling.available);
          button.setAttribute('aria-label', sibling.title + ' — ' + (sibling.color[0] || sibling.fullTitle) + (sibling.available ? '' : ' — ' + labels.soldOut));
          button.setAttribute('aria-pressed', String(sibling.handle === item.handle));
          const dot = document.createElement('span');
          dot.className = 'mno-swatch-dot';
          dot.setAttribute('aria-hidden', 'true');
          dot.style.background = sibling.color[2]
            ? 'linear-gradient(135deg,' + hex(sibling.color[1]) + ' 50%,' + hex(sibling.color[2]) + ' 50%)'
            : hex(sibling.color[1]);
          button.append(dot);
          wrap.append(button);
        });
      });
      const countText = (articles, models) => articles + ' ' + (articles === 1 ? labels.article : labels.articles) + ' · ' + models + ' ' + (models === 1 ? labels.model : labels.models);
      this.querySelector('[data-total]').textContent = countText(products.length, grouped.length);
      const more = this.querySelector('[data-more]');
      const progress = this.querySelector('[data-progress]');
      const matches = (item) =>
        (state.category === 'all' || item.category === state.category) &&
        (!state.query || item.searchText.includes(normalize(state.query))) &&
        (state.price === 'all' || item.price <= Number(state.price));
      const render = () => {
        const rows = grouped.map((group) => {
          const eligible = group.members.filter(matches);
          if (!eligible.length) return null;
          const selected = eligible.find((item) => item.handle === selection.get(group.id));
          let current = selected || eligible.find((item) => item.available) || eligible[0];
          if (!selected && state.sort === 'price') current = [...eligible].sort((a,b) => a.price - b.price)[0];
          if (!selected && state.sort === 'saving') current = [...eligible].sort((a,b) => b.saving - a.saving)[0];
          return { group, eligible, current };
        }).filter(Boolean);
        if (state.sort === 'price') rows.sort((a,b) => a.current.price - b.current.price || a.group.rank - b.group.rank);
        if (state.sort === 'saving') rows.sort((a,b) => b.current.saving - a.current.saving || a.group.rank - b.group.rank);
        const fragment = document.createDocumentFragment();
        rows.slice(0, state.limit).forEach(({ current, eligible }) => {
          current.node.querySelectorAll('[data-choose]').forEach((button) => {
            button.hidden = !eligible.some((item) => item.handle === button.dataset.choose);
          });
          fragment.append(current.node);
        });
        grid.replaceChildren(fragment);
        categoryButtons.forEach((button, key) => button.setAttribute('aria-pressed', String(key === state.category)));
        this.querySelector('[data-count]').textContent = countText(rows.reduce((total,row) => total + row.eligible.length, 0), rows.length);
        this.querySelector('[data-empty]').hidden = rows.length > 0;
        this.querySelector('[data-more-wrap]').hidden = rows.length === 0;
        more.hidden = state.limit >= rows.length;
        progress.textContent = labels.viewing + ' ' + Math.min(state.limit, rows.length) + ' ' + labels.of + ' ' + rows.length + ' ' + (rows.length === 1 ? labels.model : labels.models);
        return rows;
      };
      this.addEventListener('click', (event) => {
        const category = event.target.closest('[data-category]');
        if (category && this.contains(category)) {
          state.category = category.dataset.category;
          state.limit = initial;
          render();
        }
        const swatch = event.target.closest('[data-choose]');
        if (swatch && this.contains(swatch)) {
          const handle = swatch.dataset.choose;
          selection.set(swatch.dataset.group, handle);
          render();
          const current = products.find((item) => item.handle === handle);
          const focused = Array.from(current.node.querySelectorAll('[data-choose]')).find((button) => button.dataset.choose === handle);
          if (focused) focused.focus({ preventScroll: true });
        }
      });
      this.querySelector('[data-search]').addEventListener('input', (event) => {
        state.query = event.target.value;
        state.limit = initial;
        render();
      });
      this.querySelector('[data-price]').addEventListener('change', (event) => {
        state.price = event.target.value;
        state.limit = initial;
        render();
      });
      this.querySelector('[data-sort]').addEventListener('change', (event) => {
        state.sort = event.target.value;
        render();
      });
      more.addEventListener('click', () => {
        const previous = state.limit;
        state.limit += step;
        const rows = render();
        rows[previous]?.current.node.querySelector('[data-title-link]')?.focus({ preventScroll: true });
      });
      render();
      this.querySelector('[data-toolbar]').hidden = false;
      categoryBox.hidden = false;
    }
  });
}



  } catch(e) { console.error(e); }
})();
})();
